import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setPerformanceDashboardCaseManagers,
  setPerformanceDashboardGeneralInfo
} from 'src/store/modules/dashboard'

import { GET_PERFORMANCE_DASHBOARD } from 'src/constants'

export const getPerformanceDashboardData =
  ({ query = {} }) =>
  async (dispatch) => {
    try {
      const { items, ...generalInfo } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PERFORMANCE_DASHBOARD,
          query
        }
      })

      dispatch(setPerformanceDashboardCaseManagers(items))
      dispatch(setPerformanceDashboardGeneralInfo(generalInfo))
    } catch (err) {
      catchError(err)
    }
  }
